import React, { useEffect, useState } from "react";
import FirebaseJwt from "@presswink/firebase-jwt";
import { toast } from "react-hot-toast";
// import 'dotenv/config';


const Sidebar = ({ user, onCourseSelect }) => {
  const jwt = new FirebaseJwt("abcdefghijklmnoplqrst");
  const decodetoken = jwt.decode(sessionStorage.getItem("token"));
  const decodedGroupId = decodetoken?.payload?.group_id;
  const group_id = user?.payload?.group_id;
  const [courseVideos, setCourseVideos] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (decodedGroupId && decodedGroupId === group_id) {
      fetchCourseVideos(group_id);
    } else {
      console.error("Group ID mismatch or group_id is undefined");
    }
  }, [group_id, decodedGroupId]);

  const fetchCourseVideos = async (groupId) => {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ group_id: groupId }),
      };

      const url = `${process.env.REACT_APP_BASEURL}api.php/course_videos?group_id=${groupId}`;
      
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error(`Failed to fetch videos. Status: ${response.status}`);
      }

      const result = await response.json();
      setCourseVideos(result.data || []);
      calculateProgress(result.data || []);
    } catch (error) {
      toast.error("Failed to fetch course videos.");
    }
  };

  const calculateProgress = (courses) => {
    const totalCourses = courses.length;
    const completedCourses = courses.filter(course => course.completed).length;
    const progressPercentage = (completedCourses / totalCourses) * 100;
    setProgress(progressPercentage);
  };

  return (
    <div className="w-1/4 h-full bg-green-900 text-white fixed top-0 left-0">
      <div className="p-4 mt-[56px]">
        <h1 className="text-xl font-bold">Courses</h1>

        {/* Attractive Progress Bar */}
        <div className="mt-4">
          <h2 className="text-sm">Progress</h2>
          <div className="w-full bg-gray-300 rounded-full h-3 mt-2 relative">
            <div
              className="bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 h-3 rounded-full transition-all duration-300 ease-in-out"
              style={{ width: `${progress}%` }}
            ></div>
            <div
              className="absolute top-0 left-0 w-full h-3 bg-black opacity-25 rounded-full"
              style={{ width: "100%" }}
            ></div>
          </div>
          <p className="text-sm mt-1 text-gray-300">{progress.toFixed(2)}%</p>
        </div>

        {decodedGroupId && decodedGroupId === group_id ? (
          <ul className="mt-4 space-y-2">
            {courseVideos.length > 0 ? (
              courseVideos.map((course) => (
                <li
                  key={course.id}
                  className="hover:bg-green-700 p-2 rounded cursor-pointer"
                  onClick={() => onCourseSelect(course)}
                >
                  {course.course_name}
                </li>
              ))
            ) : (
              <li>No courses available.</li>
            )}
          </ul>
        ) : (
          <p className="text-white mt-4">You do not have access to view courses.</p>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
